/// <reference path="_references.ts"/>

module App.TimeEvent {
	export interface TimeEventUpdate {
		custom_date?: number;
		time_event_tag?: number|TimeEventTag;
		appointment?: number|App.Appointments.Appointment;
	}
	export interface TimeEvent extends TimeEventUpdate {
		id: number;
		date: number;
		time_event_tag: TimeEventTag;
		length?: number;
	}
	export interface TimeEventTag {
		id: number;
		name: string;
		paid: boolean;
		tag_type: TagType;
		color: string;
	}
	export enum TagType {
		CUSTOM = 0,
		CLOCKED_OUT = 1,
		TRAVELING = 2,
		ON_SITE = 3,
	}
}
